<template>
  

      <div class="col-auto col-width-standard border-right">
        <div class="d-flex mx-auto h-100 ">
          <div class="w-50 embed-responsive embed-responsive-1by1 p-3 align-self-center">
            <img
              :src="profilePictureUrl"
              class="img-fluid img embed-responsive-item rounded-circle"
              alt="profile picture"
            />
          </div>
          <div class="w-50 p-3 align-self-center">
            <p style="overflow-wrap: break-word">{{engagement.employeeName}}</p>
          </div>
        </div>
      </div>

      
    
</template>

<script>
import {mixins} from 'vue-chartjs'
import firebase from 'firebase/app';

export default {
  mixins: [mixins.reactiveProp],
  props: ['engagement', 'chartData'],
  components: {
  },
  data(){
    return{
      profilePictureUrl : '',
    }
  },
  
  mounted() {
    this.getProfilePicture();
  },
  methods: {
    async getProfilePicture(){
      await this.engagement;
      firebase.storage().ref('users/' + this.engagement.employeeUID + '/profile.jpg').getDownloadURL()
      .then(imgUrl=>{
        this.profilePictureUrl = imgUrl
      }).catch(error =>{
        console.log(error.message)
        this.profilePictureUrl = "https://www.medtalks.nl/images/user-placeholder.jpg"
      })
    },
  },
  async created(){
    
  }
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewBar.scss";
.img {
  object-fit: cover;
}
</style>